<i18n src="@/locales/modules/DeviceTranslate.json"></i18n>

<template>
	<CbsContextMenu
		v-if="device.can_delete || device.can_update || mixinIsCanViewKPI || mixinIsCanCreateTodo || mixinIsCanCreateRequest || mixinIsCanViewAccessory"
		v-bind="$attrs"
		:class="['device-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'device-context-menu-list' }"
	>
		<div v-if="device.can_update" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', device.id)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>

		<div
			v-if="device.can_update"
			class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickManageAccessories', { device: device, deviceId: device.id, accessoryType: $constant.ACCESSORY_TYPE.ACCESSORY })"
		>
			<i class="nucleo mr-3 nucleo-bullet-list-67" />
			{{ $t("CreateAccessory") }}
		</div>
		<div
			v-if="device.can_update"
			class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickManageAccessories', { device: device, deviceId: device.id, accessoryType: $constant.ACCESSORY_TYPE.MATERIAL })"
		>
			<i class="nucleo mr-3 nucleo-fuel" />
			{{ $t("CreateMaterial") }}
		</div>

		<div v-if="device.can_update" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickCreateKpis', { device })">
			<i class="nucleo mr-3 nucleo-settings-gear" />
			{{ $t("CreateKpis") }}
		</div>

		<div v-if="device.can_update" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickCloneKpis', device.id)">
			<i class="nucleo mr-3 nucleo-single-copy-04" />
			{{ $t("CloneKpis") }}
		</div>

		<div
			v-if="mixinIsCanCreateRequest"
			class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onClickCreateRequest', { id: device.id, type: $constant.RELATION_MODELS.DEVICE })"
		>
			<i class="nucleo mr-3 nucleo-cm-addrequest" />
			{{ $t("CreateRequest") }}
		</div>

		<div v-if="mixinIsCanCreateTodo" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickCreateTodo', device)">
			<i class="nucleo mr-3 nucleo-cm-addtask" />
			{{ $t("CreateTodo") }}
		</div>

		<div v-if="device.can_delete" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDelete', device.id)">
			<i class="nucleo mr-3 nucleo-trash-can" />
			{{ $t("Actions.Delete") }}
		</div>
	</CbsContextMenu>
	<span v-else></span>
</template>

<script>
import { kpiPermissions, todoPermissions, devicePermissions, requestPermissions, accessoryPermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "DeviceContextMenu",
	mixins: [
		getUserPermissions({
			...kpiPermissions,
			...todoPermissions,
			...devicePermissions,
			...requestPermissions,
			...accessoryPermissions
		})
	],
	components: { CbsContextMenu },
	props: {
		device: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickDelete: {},
		onClickCreateTodo: {},
		onClickCreateRequest: {},
		onClickManageChecklist: {},
		onClickManageAccessories: {}
	}
};
</script>

<style lang="scss" scoped>
.device-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.device-context-menu-list {
	.device-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
